<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1820_1915)">
      <path
        d="M9.49396 8.23618L7.54197 6.77219V3.79003C7.54197 3.49018 7.2996 3.2478 6.99975 3.2478C6.69989 3.2478 6.45752 3.49018 6.45752 3.79003V7.04333C6.45752 7.21412 6.53777 7.37518 6.67441 7.47712L8.84326 9.10377C8.94085 9.17697 9.05474 9.21221 9.16805 9.21221C9.33343 9.21221 9.49609 9.13792 9.60238 8.99478C9.78244 8.75563 9.73363 8.41566 9.49396 8.23618Z"
        fill="#FFE400"
      />
      <path
        d="M7 0C3.13996 0 0 3.13996 0 7C0 10.86 3.13996 14 7 14C10.86 14 14 10.86 14 7C14 3.13996 10.86 0 7 0ZM7 12.9156C3.73857 12.9156 1.08443 10.2614 1.08443 7C1.08443 3.73857 3.73857 1.08443 7 1.08443C10.262 1.08443 12.9156 3.73857 12.9156 7C12.9156 10.2614 10.2614 12.9156 7 12.9156Z"
        fill="#FFE400"
      />
    </g>
    <defs>
      <clipPath id="clip0_1820_1915">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
